module.exports = __webpack_public_path__ + "images/8-i0dbf603fb0bc3d1c852e369d343d3a44.svg";